import { z } from "zod/v4";

import { OrgIdNameDtoSchema } from "./organization-name-id";

export const StripeProductLinkDtoSchema = z.object({
  id: z.uuid(),
  stripeProductId: z.string(),
  stripePriceId: z.string().nullish(),
  stripeSubscriptionLinkId: z.uuid(),
  organization: OrgIdNameDtoSchema,
});

export type StripeProductLinkDto = z.infer<typeof StripeProductLinkDtoSchema>;

export const AdminStripeProductDtoSchema = z.object({
  stripeProductId: z.string(),
  name: z.string(),
  priceName: z.string(),
  quantity: z.number(),
  flatPrice: z.number(),
  priceDescription: z.string(),
});

export type AdminStripeProductDto = z.infer<typeof AdminStripeProductDtoSchema>;

export const AdminStripeProductLinkDtoSchema =
  StripeProductLinkDtoSchema.extend({
    id: z.uuid().nullable(),
    stripeProduct: AdminStripeProductDtoSchema.nullable(),
    organization: z.object({ id: z.string(), name: z.string() }),
    stripeMeterLogs: z.any().nullish(),
  });

export type AdminStripeProductLinkDto = z.infer<
  typeof AdminStripeProductLinkDtoSchema
>;

export const CreateStripeProductLinkDtoSchema = StripeProductLinkDtoSchema.omit(
  { id: true }
).extend({
  stripeSubscriptionId: z.string(),
  stripeSubscriptionLinkId: z.uuid().nullable(),
});

export type CreateStripeProductLinkDto = z.infer<
  typeof CreateStripeProductLinkDtoSchema
>;
